import React from "react";
import { Link } from "react-router-dom";
import BreadCrumb from "../components/BreadCrumb";
import hshape from "../assets/img/hshape.svg"
import FeaturedCard from "../components/Featured/FeaturedCard";
const AllCourse = () => {
  return (
    <>
    
       <section className="section-space">
            <div className="container-xl">
            <div className="row">
                    <div className="col-lg-12 text-center">
                        <div className="main-h">
                            <h2 className="m-heading">All Courses</h2>
                            <img src={hshape} className='img-fluid ' alt="logo" />
                        </div>
                    </div>
                </div>
                
                    
                       <FeaturedCard />
                   
                    
              
              
            </div>
        </section>
    </>
  );
};

export default AllCourse